export type ProjectPermission =
  | 'ASSIGN_APPROVALS'
  | 'ASSIGN_PERMISSIONS'
  | 'ASSIGN_PERMISSIONS_PERMIT_TEMPLATE'
  | 'ASSIGN_TEMPLATES'
  | 'CHANGE_STATUS'
  | 'CREATE_DIGEST'
  | 'CREATE_GROUPS'
  | 'CREATE_PERMIT_SETTINGS'
  | 'CREATE_PERMITS'
  | 'DASHBOARD'
  | 'DELETE_DIGEST'
  | 'EDIT'
  | 'EDIT_LOCATIONS'
  | 'EDIT_PROJECT_TEMPLATE'
  | 'EDIT_PROJECT_PERMIT_TEMPLATE'
  | 'EDIT_PERMISSIONS'
  | 'INVITE_USER'
  | 'LIST_APPROVALS'
  | 'LIST_DIGEST'
  | 'LIST_GROUPS'
  | 'LIST_LOCATIONS'
  | 'LIST_MEMBERS'
  | 'LIST_PERMISSIONS'
  | 'LIST_PERMIT_LOCATIONS'
  | 'LIST_PERMIT_SETTINGS'
  | 'LIST_TEMPLATES'
  | 'LIST_TEMPLATES_ISSUE'
  | 'LIST_TEMPLATES_REQUEST'
  | 'LIST_AUDITS'
  | 'MEMBER_DETAILS'
  | 'MANAGE_MEMBERS'
  | 'PREPARE_PERMIT'
  | 'READ'
  | 'READ_DIGEST'
  | 'READ_PROJECT_TEMPLATE'
  | 'REMOVE_APPROVAL_ASSIGNMENTS'
  | 'REMOVE_PERMISSION_ASSIGNMENTS'
  | 'REMOVE_TEMPLATES'
  | 'CHANGE_MEMBER_STATUS'
  | 'CHANGE_MEMBER_ROLE'
  | 'SEE_ALL_PERMITS'
  | 'SCHEDULE_INSPECTIONS'
  | 'ASSIGN_CHECKLIST_TEMPLATES'
  | 'UPDATE_USER_AUTH_GROUPS'
  | 'ASSIGN_TASK_TEMPLATES'
  | 'UPDATE_PROJECT'
  | 'EDIT_FOLDER_SITE_BOX'
  | 'CREATE_SITEBOX_DOCUMENTS'
  | 'ASSIGN_APPRAISAL_TEMPLATES'
  | 'REMOVE_APPRAISAL_TEMPLATES'
  | 'ASSIGN_DOCUMENT_ENGINE_TEMPLATES'
  | 'REMOVE_DOCUMENT_ENGINE_TEMPLATES'

export enum ProjectUsersTab {
  ALL_USERS = 'all-users',
  CHECKED_IN_USERS = 'checked-in-users',
}
